export interface MemberEvent extends Record<string, any> {
  id: string
  eventType: string
  at: string
  processed: boolean
  performedBy: string
  create: boolean
}

export class MemberEventRequest {
  memberId: string
  effectiveDate: string
  consultant: string

  beneficiaryNominationValidated = {
    eventType: "BeneficiaryNominationValidated",
    create: false,
    valid: false,
    notes: <string | null>null,
  }

  consolidationImplemented = {
    eventType: "ConsolidationImplemented",
    create: false,
    amount: 0,
    fundName: <string | null>null,
    notes: <string | null>null,
  }

  consultationPerformed = {
    eventType: "ConsultationPerformed",
    create: false,
  }

  insuranceAdviceImplemented = {
    eventType: "InsuranceAdviceImplemented",
    create: false,
    notes: <string | null>null,
  }

  investmentAdviceImplemented = {
    eventType: "InvestmentAdviceImplemented",
    create: false,
    notes: <string | null>null,
  }

  potentialConsolidationVerified = {
    eventType: "PotentialConsolidationVerified",
    create: false,
    outcome: <string | null>null,
    notes: <string | null>null,
  }

  reset(): void {
    this.beneficiaryNominationValidated.create = false
    this.consolidationImplemented.create = false
    this.investmentAdviceImplemented.create = false
    this.potentialConsolidationVerified.create = false
    this.consultationPerformed.create = false
    this.insuranceAdviceImplemented.create = false
  }

  isCreateNone(): boolean {
    return !(
      this.investmentAdviceImplemented.create ||
      this.consolidationImplemented.create ||
      this.potentialConsolidationVerified.create ||
      this.beneficiaryNominationValidated.create ||
      this.consultationPerformed.create ||
      this.insuranceAdviceImplemented.create
    )
  }
}
